import { Button, Typography } from '@mui/material';
import FormFragmentTicketText from './FormFragmentTicketText'
import { useForm } from 'react-hook-form';
import { useContext, useEffect } from 'react';
import useDataClient from '../../../hooks/useDataClient';
import { AppContext } from '../../../context';
import { JiraIssue } from '../../../types';
import { ticketsAdapter } from '../../../adapter/tickets.adapter';

interface FormPlainNewCommentProps {
    onClose: VoidFunction,
    issueTarget: JiraIssue,
    attachmentsRequired?: boolean,
    onUpdate: VoidFunction
}

export default function FormPlainNewComment({ onClose, issueTarget, attachmentsRequired, onUpdate }: Readonly<FormPlainNewCommentProps>) {
    const { control, formState, handleSubmit } = useForm();
    const appContext = useContext(AppContext);
    const sendCommentIssueClient = useDataClient<boolean>({ appContext });

    function onSubmit(data: any) {
        let updatedData = { ...issueTarget };
        updatedData.description = data.description;
        sendCommentIssueClient.executeRequest(ticketsAdapter.addComment(updatedData, data.files));
    }

    useEffect(() => {
        if (sendCommentIssueClient.status.data) {
            onUpdate();
        }
    }, [sendCommentIssueClient.status.data])

    return (
        <form className="form-contain" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <fieldset>
                <Typography component={'legend'} variant='caption' sx={{ color: 'text.primary' }}>+ Agregar comentario</Typography>
                <FormFragmentTicketText formState={formState} control={control} attachmentsRequired={attachmentsRequired} />
                <div className="form-contain-row">
                    <Button
                        type='button'
                        variant='outlined'
                        fullWidth
                        onClick={onClose}
                        size='small'
                        disabled={appContext?.loading}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type='submit'
                        variant='outlined'
                        className='app-btn-color'
                        fullWidth
                        size='small'
                        disabled={appContext?.loading}
                    >
                        Enviar
                    </Button>
                </div>
            </fieldset>
        </form>
    )
}
